import { create } from "zustand";

const useImageStore = create((set) => ({
  isImgLoading: true,
  setIsImgLoading: (loading) => set({ isImgLoading: loading }),
}));

export default useImageStore;
